import { InjectionToken } from '@angular/core';
import {
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'struttura-prospetto';
export const ENTITY_PLURAL = 'struttura prospetto';
export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Lettera',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'lettera',
    sortable: true,
    minWidth: 110,
    maxWidth: 110,
  },
  {
    elementLabel: 'Rif. 1',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif1',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 2',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif2',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 3',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif3',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Rif. 4',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'rif4',
    sortable: true,
    minWidth: 90,
    maxWidth: 90,
  },
  {
    elementLabel: 'Descrizione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'descrizione',
    sortable: true,
    minWidth: 400,
  },
  // {
  //   elementLabel: 'Padre',
  //   filterType: FilterType.number,
  //   fieldType: FieldType.integer,
  //   field: 'idPadre',
  //   initialHideColumn: true,
  // },
  // {
  //   elementLabel: 'Livello',
  //   filterType: FilterType.number,
  //   fieldType: FieldType.integer,
  //   field: 'livello',
  //   initialHideColumn: true,
  // },
  {
    elementLabel: 'Nota 1',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'nota1',
    sortable: true,
    minWidth: 100,
    maxWidth: 140,
  },
  {
    elementLabel: 'Nota 2',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'nota2',
    sortable: true,
    minWidth: 100,
    maxWidth: 140,
  },
  {
    elementLabel: 'Xbrl',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'xbrl',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Di cui',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swDiCui',
    sortable: true,
    minWidth: 80,
    maxWidth: 80,
    initialHideColumn: true,
  },
  {
    elementLabel: 'Tot/Par',
    filterType: FilterType.boolean,
    fieldType: FieldType.boolean,
    field: 'swTotPar',
    initialHideColumn: true,
  },
  {
    elementLabel: 'Anno inizio',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'annoInizio',
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
  },
  {
    elementLabel: 'Anno Fine',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    field: 'annoFine',
    sortable: true,
    minWidth: 100,
    maxWidth: 110,
  },
  // {
  //   elementLabel: 'SW_NODETT_AP',
  //   filterType: FilterType.boolean,
  //   fieldType: FieldType.boolean,
  //   field: 'swNodettAp',
  //   initialHideColumn: true,
  // },
  // {
  //   elementLabel: 'Metadati',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'metadati',
  //   initialHideColumn: true,
  // },
  {
    elementLabel: 'Ordine',
    filterType: FilterType.number,
    fieldType: FieldType.integer,
    sort: 'asc',
    field: 'ordine',
    initialHideColumn: true,
  },
  // {
  //   elementLabel: 'EST_STAMP',
  //   filterType: FilterType.text,
  //   fieldType: FieldType.text,
  //   field: 'estStamp',
  //   initialHideColumn: true,
  // },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
